<form [formGroup]="tagForm">
  <div id="tag-array" formArrayName="tagFormArray">
    <div
      *ngFor="let tagPair of tagForm.value.tagFormArray; index as i; trackBy: tagTrackBy"
      class="flex-center-row tag-row"
      [formGroupName]="i"
    >
      <input id="tag-name" class="arpio-input tag-input" type="text" formControlName="tagName" placeholder="Tag" />
      <div class="has-value-div">with value</div>
      <input id="tag-value" class="arpio-input tag-input" type="text" formControlName="tagValue" placeholder="Value" />
      <div class="flex-center-column remove-button-div">
        <button class="remove-button" *ngIf="tagPair.tagName.length > 0" (click)="removeTagAt(i)">
          <i class="fa-utility fa-semibold fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>
</form>
